import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-localize-redux';
import Badge from '../../components/atoms/Badge';
import { IconSizes } from '../../components/foundations/Icon';
import tableCss from '../../components/organisms/Table.css';
import CellLoader from '../../components/widgets/CellLoader';
import { deriveSectionsAccess } from '../../selectors/navigation';
import { SECTIONS_PAGES_CONFIG } from '../sections';
import { SectionPermissionSchema } from '../types';
import { CUSTOM_ACCESS_TYPE, translationPrefix as translationRootPrefix } from '../utils';
import AccessTypeIcon, { BADGE_COLORS_BY_ACCESS_TYPE } from './AccessTypeIcon';
import css from './PermissionsCell.css';

const translationPrefix = `${translationRootPrefix}.MANAGE_PERMISSIONS_PAGE`;

const PermissionsCell = ({ key, isLoading, sectionPermissions, loaderClass = '' }) => {
    const renderStep = ({ step, cards }) => {
        const sectionNames = cards.flatMap(card => card.parts.flatMap(part => part.sectionNames));
        const featureAccess = deriveSectionsAccess(
            sectionPermissions.filter(({ name }) => sectionNames.includes(name))
        );
        const accessType = featureAccess.isSingleAccessLevel ? featureAccess.accessType : CUSTOM_ACCESS_TYPE;

        return (
            <Badge variant={BADGE_COLORS_BY_ACCESS_TYPE[accessType]} className={css.stepContainer}>
                <AccessTypeIcon accessType={accessType} size={IconSizes.X_SMALL} wrapperClass={css.accessTypeIcon} />
                <Translate id={`${translationPrefix}.TABS.${step.toUpperCase()}`} />
            </Badge>
        );
    };

    return (
        <td className={tableCss.rowIndexCell} key={key}>
            {isLoading ? (
                <CellLoader loaderClass={loaderClass} />
            ) : (
                <div className={css.cellContent}>{SECTIONS_PAGES_CONFIG.map(renderStep)}</div>
            )}
        </td>
    );
};

PermissionsCell.propTypes = {
    key: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    sectionPermissions: PropTypes.arrayOf(SectionPermissionSchema).isRequired,
    loaderClass: PropTypes.string,
};

export default PermissionsCell;
